import React from 'react';
import PropTypes from 'prop-types';
import { determineTicketDisplayName } from '../../../util';
import { useSelector } from 'react-redux';
import { validCommunicationType } from 'constants/conversationTypes';
import { isLiveChat } from '../../../util/chat';
import noop from 'lodash/noop';
import { NOMINATED_FOR_REVIEW } from 'constants/ticketStatuses';
import {
  ArrowIcon,
  Button,
  TopLabel,
  BotLabel,
  Icon,
  TicketWrapper,
  CtaTicketsTabWrapper,
} from './CtaTicketsHolder.styles';

const propTypes = {
  status: PropTypes.string.isRequired,
  tickets: PropTypes.shape({
    allTickets: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  iconSrc: PropTypes.string.isRequired,
  renderCtaText: PropTypes.func.isRequired,
  onTicketButtonClick: PropTypes.func,
};

const getTicketTypeLabel = (communicationType) => {
  if (!communicationType || typeof communicationType !== 'string') {
    return '';
  }

  if (isLiveChat(communicationType)) {
    return 'chat';
  } else if (communicationType === validCommunicationType.EMAIL_MESSAGE) {
    return 'email';
  }

  return '';
};

const getButtonText = (status) => {
  if (status === NOMINATED_FOR_REVIEW) {
    return 'review';
  }
};

const getTabWrapperId = (status) => {
  if (status === NOMINATED_FOR_REVIEW) {
    return 'review-tickets-tab';
  }
};

export default function CtaTicketsHolder({ status, tickets, iconSrc, renderCtaText, onTicketButtonClick = noop }) {
  const selectedTicketId = useSelector((state) => state.selectedTicketId);

  const renderTickets = (ticket) => {
    if (!ticket) {
      return;
    }

    const { ticketId, simplrTicketNumber, communicationType } = ticket;

    if (!ticketId || !simplrTicketNumber) {
      return null;
    }

    const isSelected = selectedTicketId === ticketId;
    const customerName = determineTicketDisplayName(ticket, false);
    const ticketTypeLabel = getTicketTypeLabel(communicationType);
    const handleTicketClick = () => {
      onTicketButtonClick(ticketId);
    };

    return (
      <TicketWrapper key={ticketId} selected={isSelected}>
        <Icon url={iconSrc} />
        <TopLabel selected={isSelected}>{renderCtaText(ticketTypeLabel)}</TopLabel>
        <BotLabel selected={isSelected}>
          {customerName}
          <ArrowIcon>→</ArrowIcon>
          {simplrTicketNumber}
        </BotLabel>
        <Button selected={isSelected} onClick={handleTicketClick}>
          {getButtonText(status)}
        </Button>
      </TicketWrapper>
    );
  };

  return (
    <>
      {!!tickets.allTickets.length && (
        <CtaTicketsTabWrapper data-testid={getTabWrapperId(status)} id={getTabWrapperId(status)}>
          {renderTickets(tickets[tickets.allTickets[0]])}
        </CtaTicketsTabWrapper>
      )}
    </>
  );
}

CtaTicketsHolder.propTypes = propTypes;
